export const getChatBodyScrollLockHandlers = () => ({
  onMouseEnter: () => {
    document.body.style.overflow = 'hidden'
  },
  onMouseLeave: () => {
    document.body.style.overflow = ''
  },
  onTouchStart: () => {
    document.body.style.overflow = 'hidden'
    document.body.style.touchAction = 'none'
  },
  onTouchEnd: () => {
    setTimeout(() => {
      document.body.style.overflow = ''
      document.body.style.touchAction = ''
    }, 100)
  },
})